// extracted by mini-css-extract-plugin
export default {"container":"YDMFIP","text":"Hmcc4D","spinner":"BqlgJ7"};